import { useEffect } from "react";
import { LoadingSpinner } from "../../../../components";

export const Loading = () => {
  useEffect(() => {
    const navStart = Number(sessionStorage.getItem("dashboard-nav-start") ?? 0);
    const t = navStart ? (performance.now() - navStart).toFixed(0) : "?";
    console.log(`[LOADING] mounted at ${t}ms`);
    return () => {
      const t2 = navStart ? (performance.now() - navStart).toFixed(0) : "?";
      console.log(`[LOADING] unmounted at ${t2}ms`);
    };
  }, []);

  return (
    <div className="flex justify-center items-center h-screen w-full">
      <LoadingSpinner />
    </div>
  );
};
